import * as React from 'react';

type RadioInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function RadioInput({
  className,
  name,
  id,
  disabled,
  error,
  checked,
  value,
  onChange,
}: RadioInputProps) {
  return (
    <input
      style={{ boxShadow: 'none' }}
      className={`${className} ${error ? 'text-river-red' : ''} `}
      type="radio"
      name={name}
      id={id}
      disabled={disabled}
      value={value}
      onChange={onChange}
      checked={checked}
    />
  );
}

RadioInput.defaultProps = {
  className: '',
  id: '',
  disabled: false,
  error: false,
};

export default RadioInput;
